import { canv } from '@/canv/global.js'
import { elementBase } from '@/elementBase/elementBase.js'
import { widgetOption } from '@/widgetMenu/widgetMenu';
import {
    isBrowser,
    getStringProperty,
    getNumberProperty,
    getColorProperty,
} from '@/canv/utils.js';
import { generateKeyBetween } from '@/helpers/fractional-indexing.js'

import { textWidget } from '@/elements/text/text.js'
import { getFontSize } from '@/utils';

export class treeNodeWidget extends elementBase {

    constructor() {
        super();
        this.width = this.minWidth;
        this.fastAction = "";

        this.textPart = new textWidget(this.startX + this.horizontalPadding, this.startY + this.topPadding);
        this.textPart.setKeepMinWidth(false);

        this.rotatable = false;

        this.disableConnectors = true;
        this.disableLevelLines = true;

        this.updateDims();
    }


    updateDims() {
        if (!isBrowser()) return;


        this.textPart.startX = this.startX + this.horizontalPadding;
        this.textPart.startY = this.startY + this.height/2 - this.textPart.height/2 + this.textPart.lines[0].textHeight;

        this.textPart.updateDims();

        if (this.textPart.symbolsCount == 0) {
            this.width = this.minWidth;
        } else {
            this.width = 2*this.horizontalPadding + this.textPart.width;
        }

        this.updateBase(this.startX, this.startY, this.width, this.height);
    }



    // Draw

    drawRoundedRect(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+w, y,   x+w, y+h, r);
        canv.ctx.arcTo(x+w, y+h, x,   y+h, r);
        canv.ctx.arcTo(x,   y+h, x,   y,   r);
        canv.ctx.arcTo(x,   y,   x+w, y,   r);
        canv.ctx.closePath();
    }

    shouldDraw() {

        if (this.parent.isGroupOnScreen()) return true;

        // если кто-то из child на эране, то рисуем, чтобы нарисовать связи
        for (var i = 0; i < this.children.length; i++) {
            var child = canv.canvasController.FindByUID(this.children[i].UID);
            if (child == null) return; // не ожидаемо

            if (child.parent.isGroupOnScreen()) {
                return true;
            }
        }
    }

    draw() {

        //canv.ctx.fillText(this.UID, this.startX, this.startY - 10);

        canv.ctx.lineWidth = 4;

        if (this.parentNode == "" && this.color !== "transparent") {
            canv.ctx.strokeStyle = this.color;
            this.drawRoundedRect(this.startX, this.startY, this.width, this.height, canv.actionManager.getConstant(50));
            canv.ctx.stroke();
        }

        if (this.shouldHighlight()) {
            canv.ctx.strokeStyle = "#0d99ff";
            this.drawRoundedRect(this.startX, this.startY, this.width, this.height, canv.actionManager.getConstant(50));
            canv.ctx.stroke();
        }

        canv.ctx.strokeStyle = this.color;

        // рисуем связи
        for (var i = 0; i < this.children.length; i++) {
            var widget = this.children[i];
            if (widget == null) continue;
            var dir = this.direction;

            if (this.direction == "") {
                dir = widget.direction;
            }

            var fixedGap = canv.actionManager.getConstant(50);
            if (dir === "right") {
                canv.ctx.beginPath();
                canv.ctx.moveTo(this.startX + this.width, this.startY + this.height/2);
                canv.ctx.bezierCurveTo(this.startX + this.width + fixedGap, this.startY + this.height/2, widget.startX - fixedGap, widget.startY + widget.height/2, widget.startX, widget.startY + widget.height/2)
                canv.ctx.stroke();
                canv.ctx.closePath();
            } else {
                canv.ctx.beginPath();
                canv.ctx.moveTo(this.startX, this.startY + this.height/2);
                canv.ctx.bezierCurveTo(this.startX - fixedGap, this.startY + this.height/2, widget.startX + widget.width + fixedGap, widget.startY + widget.height/2, widget.startX + widget.width, widget.startY + widget.height/2)
                canv.ctx.stroke();
                canv.ctx.closePath();
            }

        }

        // рисуем + при наведении
        var plusSide = this.shouldShowPlus();
        if (plusSide != "") {
            var radius = canv.actionManager.getZoomConstant(15);
            var margin = radius;
            var memOpacity = canv.ctx.globalAlpha;

            var centerX = this.startX + this.width + margin + radius;
            var centerY = this.startY + this.height/2;

            if (plusSide == "left") {
                centerX = this.startX - margin - radius;
            }

            canv.ctx.fillStyle = "#CCCCCC";

            if (this.isOverLeftPlus() || this.isOverRightPlus()) {
                canv.ctx.fillStyle = "blue";
            }

            canv.ctx.globalAlpha = 0.5;
            canv.ctx.beginPath();
            canv.ctx.arc(centerX, centerY, radius, 0, 2*Math.PI);
            canv.ctx.fill();

            canv.ctx.fillStyle = "white";
            canv.ctx.globalAlpha = memOpacity;

            var plusWidth = radius * 0.2;
            var plusHeight = radius * 1.2;
            canv.ctx.fillRect(centerX - plusWidth/2, this.startY + this.height/2 - plusHeight/2, plusWidth, plusHeight);
            canv.ctx.fillRect(centerX - plusHeight/2, this.startY + this.height/2 - plusWidth/2, plusHeight, plusWidth);
        }

        this.textPart.draw();
    }

    // TryAction

    TryAction(type) {

        if (type == "keyboardDown" && canv.keyboard.isEnter()) {
            if (this.parentNode == "") return;

            this.reset();
            var parent = canv.canvasController.FindByUID(this.parentNode);
            parent.addChild(this.direction);
            return;
        }

        this.textPart.TryAction(type);
        this.updateDims();
        if (type == "mousedown" && !this.textPart.isOver()) {
            canv.toolBox.TryGetToolByName("cursorTool").turnMode("");
        }
    }


    // Becoming

    becomingFocused() {
        super.becomingFocused();
        this.fixState("full");
        this.textPart.becomingFocused();
    }

    becomingSelected() {
        super.becomingSelected();
        this.textPart.becomingSelected();
    }

    reset() {
        if (this.isFocused) {
            canv.eventManager.openRecord();
            this.parent.saveWidgets("full");
            canv.eventManager.closeRecord();
        }
        super.reset();
        this.textPart.reset();
    }

    beforeDeletion() {

        /*
            Нужно чтобы удаялемая нода ни на кого не ссылалась и на нее никто не ссылался
        */

        this.runTopSelectedFromRoot();

        if (this.UID == this.topSelected && this.parentNode != "") {
            canv.eventManager.createTouchEvent(this.parentNode);
        }

        // отвязываем ноду, чтобы delete -> undo -> redo (нода будет удаляться срествами build event и не будет отвязыввать автоматически)
        this.fixState("parentNode");
        this.registerNodeParent("");
        this.saveState("parentNode");

        let childs = [];
        childs.splice(0, 0, ...this.children);

        for (let i = 0; i < childs.length; i++) {
            // отцепляем детей
            childs[i].fixState("parentNode");
            childs[i].registerNodeParent("");
            childs[i].saveState("parentNode");
            if (!canv.canvasController.isInSelectedDeep(childs[i].parent)) { // deep на всякий, нода не должна оказаться в группе
                canv.canvasController.deleteProcessor(childs[i].parent);
            }
        }
    }

    runTopSelectedFromRoot() {
        if (this.parentNode == "") {
            this.setTopSelected("");
        } else {
            let parentWidget = canv.canvasController.FindByUID(this.parentNode);
            if (parentWidget != null) { // такое получается, если удалить две ноды. Первое удаление прерывает цепочку. Но topSelected уже у все есть
                parentWidget.runTopSelectedFromRoot();
            }
        }

    }

    setTopSelected(topSelected) {

        if (topSelected == "") {
            if (canv.canvasController.isInSelectedDeep(this.parent)) {
                topSelected = this.UID;
            }
        }

        this.topSelected = topSelected;

        for (let i = 0; i < this.children.length; i++) {
            this.children[i].setTopSelected(topSelected);
        }
    }



    // безопасные helpers

    shouldShowPlus() {
        var plusSide = "";

        var radius = canv.actionManager.getZoomConstant(15); // радиус плюса

        var pt = canv.actionManager.getActionPoint();

        if (this.direction !== "left" && pt.x > this.startX + this.width/2 && pt.x < this.startX + this.width + 3*radius) {
            if (pt.y > this.startY && pt.y < this.startY + this.height) {
                plusSide = "right";
            }
        }

        if (this.direction !== "right" && pt.x > this.startX - 3*radius && pt.x < this.startX + this.width/2) {
            if (pt.y > this.startY && pt.y < this.startY + this.height) {
                plusSide = "left";
            }
        }

        return plusSide;
    }

    isOverRightPlus() {
        if (this.direction === "left") {
            return false;
        }

        var radius = canv.actionManager.getZoomConstant(15); // радиус плюса

        var pt = canv.actionManager.getActionPoint();

        if (pt.x > this.startX + this.width + radius && pt.x < this.startX + this.width + 3*radius) {
            if (pt.y > this.startY + this.height/2 - radius && pt.y < this.startY + this.height/2 + radius) {
                return true;
            }
        }

        return false;
    }

    isOverLeftPlus() {
        if (this.direction == "right") {
            return false;
        }

        var radius = canv.actionManager.getZoomConstant(15); // радиус плюса

        var pt = canv.actionManager.getActionPoint();

        if (pt.x > this.startX - 3*radius && pt.x < this.startX - radius) {
            if (pt.y > this.startY + this.height/2 - radius && pt.y < this.startY + this.height/2 + radius) {
                return true;
            }
        }

        return false;
    }

    isMovingNode() {
        var cursorTool = canv.toolBox.TryGetToolByName("cursorTool");
        if (cursorTool.mode == "dragging" || cursorTool.mode == "fastDragging") {
            if (canv.canvasController.selected.length == 1 && canv.canvasController.selected[0].isItemWrapper() && canv.canvasController.selected[0].onlyChild().constructorName == "treeNode") {
                return true;
            }
        }

        return false;
    }

    shouldHighlight() {
        if (!this.isMovingNode()) return false;

        var movingNode = canv.canvasController.selected[0].onlyChild();
        var movingNodeEqualThis = movingNode.UID == this.UID;

        var pt = canv.actionManager.getActionPoint();

        if (!movingNodeEqualThis && pt.x >= this.startX && pt.x <= this.startX + this.width && pt.y >= this.startY && pt.y <= this.startY + this.height) {
            return true;
        }
    }

    preparePaste() {
        this.parentNode = "";
        this.direction = "";
    }



    // Actions

    // меняет направление ветки, кидает delta
    setDirection(newDirection, throwEvents = false) {
        // при вызове из TryChangeDirection throwEvents == false
        // мы не кидаем event потому, что setDirection влияет только на startX, startY, direction передвигаемой ноды и ее children
        // все эти поле мы сохраним в translatingStop->saveStateRecursively

        if (throwEvents && this.direction != newDirection) {
            this.fixState("move");
            this.direction = newDirection;
            this.saveState();
        } else {
            this.direction = newDirection;
        }

        for (var i = 0; i < this.children.length; i++) {
            var childNode = this.children[i];
            if (childNode == null) return; // на всякий

            if (childNode.direction == "right" && newDirection == "left") {
                var gap = childNode.startX - this.startX - this.width;
                var newStartX = this.startX - gap - childNode.width;
                if (throwEvents) {
                    childNode.translateInnerAndEvent(newStartX - childNode.startX, 0);
                } else {
                    childNode.translateInner(newStartX - childNode.startX, 0);
                }
            } else if (childNode.direction == "left" && newDirection == "right") {
                var gap = this.startX - childNode.startX - childNode.width;
                var newStartX = this.startX + this.width + gap;
                if (throwEvents) {
                    childNode.translateInnerAndEvent(newStartX - childNode.startX, 0);
                } else {
                    childNode.translateInner(newStartX - childNode.startX, 0);
                }
            }
            childNode.setDirection(newDirection, throwEvents);
        }
    }

    // двигает ноды и кидает delta, вызывается из widget menu
    alignChilds(direction) {

        var childsSet = [];

        for (var i = 0; i < this.children.length; i++) {
            var childNode = this.children[i];
            if (childNode.direction != direction) continue;

            childsSet.push(childNode);
        }


        var accumHeight = 0;
        var gap = this.height;
        for (var i = 0; i < childsSet.length; i++) {
            var childNode = childsSet[i];
            childNode.alignChilds(direction);

            var box = childNode.getBox();

            accumHeight += (box["max"] - box["min"]);

            if (i != childsSet.length - 1) {
                accumHeight += gap;
            }
        }

        var topStartY = this.startY + this.height/2 - accumHeight/2;


        for (var i = 0; i < childsSet.length; i++) {
            var childNode = childsSet[i];

            var box = childNode.getBox();
            var boxHeight = box["max"] - box["min"];

            var minorDistanceMove = this.startX + this.width - childNode.startX + canv.actionManager.getConstant(150);
            if (direction == "left") {
                minorDistanceMove = this.startX - childNode.startX - childNode.width - canv.actionManager.getConstant(150);
            }
            childNode.translateInnerAndEvent(minorDistanceMove, topStartY - box["min"]);
            topStartY = topStartY + boxHeight + gap;
        }


    }

    // кидает delta
    registerChild(childUID) {

        this.fixState("structure");
        this.children.push(childUID);
        this.saveState();

        var child = canv.canvasController.FindByUID(childUID);
        if (child == null) return; // не ожидаемо

        child.fixState("structure");
        child.parentNode = this.UID;
        child.saveState();
    }

    registerNodeParent(parentWidgetUID = "") {
        if (this.parentNode != "") {
            let currentParentWidget = canv.canvasController.FindByUID(this.parentNode);
            if (currentParentWidget != null) {
                for (var i = 0; i < currentParentWidget.children.length; i++) {
                    if (currentParentWidget.children[i].UID == this.UID) {
                        currentParentWidget.children.splice(i, 1);
                    }
                }
            }
        }

        this.parentNode = parentWidgetUID;
        let parentWidget = canv.canvasController.FindByUID(parentWidgetUID);
        if (parentWidget != null) {
            parentWidget.children.push(this);
        }

    }

    isNeedInit() {
        return true;
    }

    initWidget() {
        if (this.parentNode == "") return;

        this.registerNodeParent(this.parentNode);
    }

    checkDeletion(UIDs) {
        if (this.children.length != 0) {
            return false;
        }

        return true;
    }





    // translate resize

    translatingStart() {
        this.fixStateRecursively("move");
    }

    translate(x, y) {

        this.startX += x;
        this.startY += y;
        for (var i = 0; i < this.children.length; i++) {
            var widget = this.children[i];
            widget.translateInner(x, y, true);
        }


        this.updateDims();
        this.TryChangeDirection();
    }

    translateInner(x, y, ignoreSelected = false) {
        // везде в коде вызывается просто translateInner(x, y)
        // translateInner(x, y, true) вызывается только из translate, чтобы children не двигались если выбраны
        if (ignoreSelected) {
            // не двигаемся если нас двигал родитель, а мы есть в selected
            if (canv.canvasController.isInSelectedDeep(this.parent)) {
                return;
            }
        }

        this.startX += x;
        this.startY += y;
        for (var i = 0; i < this.children.length; i++) {
            var widget = this.children[i];
            widget.translateInner(x, y, ignoreSelected);
        }


        this.updateDims();
    }

    // вызывает setDirection по предикату
    TryChangeDirection() {
        // вызывается из translate, setDirection не кидает event кода двигает ноды, потому что они все будут позже saveState через saveStateRecursively в translatingStop
        // То-есть saveDirection тут просто дополнительно двигает child nodes
        if (this.parentNode != "") {
            var parent = canv.canvasController.FindByUID(this.parentNode);
            var cursorTool = canv.toolBox.TryGetToolByName("cursorTool");
            var movingMode = cursorTool.mode == "dragging" || cursorTool.mode == "fastDragging"
            var movingOnlyTreeNode = canv.canvasController.selected.length == 1 && canv.canvasController.selected[0].isItemWrapper() && canv.canvasController.selected[0].onlyChild().constructorName == "treeNode";


            if (parent.parentNode == "" && movingMode && movingOnlyTreeNode) {
                var pt = canv.actionManager.getActionPoint();
                if (pt.x <= parent.startX  + parent.width/2 && this.direction == "right") {
                    // меняем direction у root child
                    this.setDirection("left");
                } else if (pt.x > parent.startX  + parent.width/2 && this.direction == "left") {
                    // меняем direction у root child
                    this.setDirection("right");
                }
            }
        }
    }

    // делает translateInner и сам кидает delta
    translateInnerAndEvent(x, y) {
        this.fixStateRecursively("move");
        this.translateInner(x, y);
        this.saveStateRecursively();
    }

    translatingStop() {
        this.saveStateRecursively();
    }

    translatingAfter() {
        // тут мы уже все подвинули и сохранили. Делаем пост модерирование.

        if (this.isMovingNode() && this.parentNode != "") {
            var items = canv.canvasController.getVisibleItemWrappersExceptSelected();
            for (var i = 0; i < items.length; i++) {
                var parentCandidate = items[i].onlyChild();

                if (parentCandidate.constructorName != "treeNode") continue;
                if (parentCandidate.UID == this.parentNode) continue;

                var pt = canv.actionManager.getActionPoint();

                if (pt.x >= parentCandidate.startX && pt.x <= parentCandidate.startX + parentCandidate.width && pt.y >= parentCandidate.startY && pt.y <= parentCandidate.startY + parentCandidate.height) {

                    canv.eventManager.createTouchEvent(parentCandidate.UID);

                    this.fixState("parentNode");
                    this.registerNodeParent(parentCandidate.UID);
                    this.saveState();

                    var newDirection = parentCandidate.direction;
                    if (newDirection == "") {
                        newDirection = "right";
                    }
                    this.setDirection(newDirection, true);

                    var newX = parentCandidate.startX + parentCandidate.width + canv.actionManager.getConstant(150);
                    if (newDirection == "left") {
                        newX = parentCandidate.startX - parentCandidate.width - canv.actionManager.getConstant(150);
                    }

                    var newY = parentCandidate.startY;
                    this.translateInnerAndEvent(newX - this.startX, newY - this.startY);

                    parentCandidate.alignAroundAndUp(this.UID, this.getBox());

                    break;
                }
            }
        }


        // alignAroundAndUp умеет двигать произвольные ноды, но сохраняет delta
        if (this.parentNode != "") {
            var parent = canv.canvasController.FindByUID(this.parentNode);
            var boxData = this.getBox();
            parent.alignAroundAndUp(this.UID, boxData);
        }





    }

    fixStateRecursively(reason) {
        this.fixState(reason);

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            child.fixStateRecursively(reason);
        }
    }

    saveStateRecursively() {
        this.saveState();

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            child.saveStateRecursively();
        }
    }

    resize(x, y, catchPointer) {}




    // isInteraction, вызывает addChild

    isInteraction() {

        if (this.isOverRightPlus()) {
            return {"type": "click"};
        }

        if (this.isOverLeftPlus()) {
            return {"type": "click"};
        }

        return {"type": "none"};
    }

    isInteractionClick() {
        if (this.isOverRightPlus()) {
            this.addChild("right");
        }

        if (this.isOverLeftPlus()) {
            this.addChild("left");
        }
    }

    // создает child and throw build, delta
    addChild(direction) {
        var mmTool = canv.toolBox.TryGetToolByName("mindMapTool");
        var newX = this.startX + this.width + canv.actionManager.getConstant(150);
        if (direction == "left") {
            var afterCreationWidth = this.minWidth + 2*this.horizontalPadding;
            newX = this.startX - afterCreationWidth - canv.actionManager.getConstant(150);
        }
        var newY = this.startY;
        if (this.children.length != 0) {
            // высота у всех одинаковая
            var bottomEdge = undefined;
            for (var i = 0; i < this.children.length; i++) {
                var widget = this.children[i];
                if (widget.direction != direction) continue;
                if (bottomEdge == undefined || widget.startY + widget.height > bottomEdge) {
                    bottomEdge = widget.startY + widget.height;
                }
            }

            if (bottomEdge != undefined) {
                newY = bottomEdge;
            }
        }

        var newChild = mmTool.createNode("", newX, newY, direction, this.textPart.fontSize, this.textPart.fontBold, this.height);


        canv.canvasController.addGroup(newChild);

        canv.eventManager.openRecord();
        canv.eventManager.createTouchEvent(this.UID);
        canv.eventManager.createBuildEvent("create", newChild);

        newChild.onlyChild().fixState("parentNode");
        newChild.onlyChild().registerNodeParent(this.UID);
        newChild.onlyChild().saveState();

        // выкидывает delta
        this.alignAroundAndUp(newChild.onlyChild().UID, newChild.onlyChild().getBox());

        canv.eventManager.closeRecord();


        canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(newChild);

    }



    // выравнивание соседей

    getBox() {
        var boxData = {
            "min": this.startY,
            "max": this.startY + this.height
        };

        for (var i = 0; i < this.children.length; i++) {
            var widget = this.children[i];
            var res = widget.getBox();
            if (res["min"] < boxData["min"]) {
                boxData["min"] = res["min"];
            }

            if (res["max"] > boxData["max"]) {
                boxData["max"] = res["max"];
            }
        }

        return boxData;
    }

    // вызывается только из alignAroundAndUp, двигает соседей выбрасывает для них delta
    repositionAround(aroundUID, boxData) {

        if (this.children.length == 0) return;

        var compare = function ( widgetA, widgetB ) {
            if ( widgetA.startY < widgetB.startY ){
                return -1;
            }
            if ( widgetA.startY > widgetB.startY ){
                return 1;
            }
            return 0;
        }

        this.children.sort(compare);
        var aroundIndex = 0;

        for (var i = 0; i < this.children.length; i++) {
            if (this.children[i].UID == aroundUID) {
                aroundIndex = i;
            }
        }

        var aroundWidget = this.children[aroundIndex];

        var border = boxData["min"];
        var margin = this.height; // такое значение нужно, чтобы когда например root и два сына, между нимибыла одна высота и все выглядело выравнено
        for (var i = aroundIndex - 1; i >= 0; i--) {
           var widget = this.children[i];

            // чтобы при движение нод справа не выравнивать ноды слева
            // актуально только для root
            if (widget.direction != aroundWidget.direction) continue;

            var currentBox = widget.getBox();
            var newBorder = currentBox["min"];
            if (currentBox["max"] + margin > border) {
                widget.translateInnerAndEvent(0, border - currentBox["max"] - margin);
                newBorder = newBorder + (border - currentBox["max"] - margin);
            }
            border = newBorder;
        }

        border = boxData["max"];
        for (var i = aroundIndex + 1; i < this.children.length; i++) {
            var widget = this.children[i];

            // чтобы при движение нод справа не выравнивать ноды слева
            // актуально только для root
            if (widget.direction != aroundWidget.direction) continue;

            var currentBox = widget.getBox();
            var newBorder = currentBox["max"];
            if (currentBox["min"] - margin < border) {
                widget.translateInnerAndEvent(0, border - currentBox["min"] + margin);
                newBorder += border - currentBox["min"] + margin;
            }
            border = newBorder;
        }

    }

    // вызывает repositionAround и alignAroundAndUp для parent
    alignAroundAndUp(aroundUID, boxData) {
        this.repositionAround(aroundUID, boxData);
        var boxData = this.getBox();
        if (this.parentNode != "") {
            var parent = canv.canvasController.FindByUID(this.parentNode);
            parent.alignAroundAndUp(this.UID, boxData);
        }
    }




    // Далее обработчики menu

    menuColor(color) {
        this.color = color;
    }

    alignChildsMenu() {
        this.alignChilds("right");
        this.alignChilds("left");
    }

    menuUpdateTextParamsChilds(size, boldness, height, horizontalPadding) {

        this.fixState("full");
        this.textPart.lines[0].setTextSize(size, 0, this.textPart.lines[0].items.length);
        this.textPart.lines[0].setTextBold(boldness, 0, this.textPart.lines[0].items.length);
        this.textPart.fontSize = size;
        this.textPart.fontBold = boldness;
        this.textPart.updateDims();
        this.height = height;
        this.horizontalPadding = horizontalPadding;
        this.saveState();

        this.updateDims();

        for (var i = 0; i < this.children.length; i++) {
            var childNode = this.children[i];
            childNode.menuUpdateTextParamsChilds(size, boldness, height, horizontalPadding);
        }

    }

    menuUpdateTextParams(size, boldness) {

        var oldTextHeight = this.textPart.height;
        this.textPart.lines[0].setTextSize(size, 0, this.textPart.lines[0].items.length);
        this.textPart.lines[0].setTextBold(boldness, 0, this.textPart.lines[0].items.length);
        this.textPart.fontSize = size;
        this.textPart.fontBold = boldness;
        this.textPart.updateDims();
        var newTextHeight = this.textPart.height;

        var ratio = newTextHeight / oldTextHeight;
        this.height *= ratio;
        this.horizontalPadding *= ratio;

        this.updateDims();

        for (var i = 0; i < this.children.length; i++) {
            var childNode = this.children[i];
           childNode.menuUpdateTextParamsChilds(size, boldness, this.height, this.horizontalPadding);
        }

        // выравнивает и кидает delta
        this.alignChildsMenu();
    }

    menuTextSize(size) {
        const newSize = getFontSize(size);
        this.menuUpdateTextParams(newSize, this.textPart.fontBold);
    }

    menuTextBold(boldness) {
        this.menuUpdateTextParams(this.textPart.fontSize, boldness);
    }

    getWidgetOptions() {
        var widgetOptions = [];

        widgetOptions.push(new widgetOption("color", this.color, this.UID));
        widgetOptions.push(new widgetOption("alignChilds", "", this.UID));

        if (this.parentNode == "") {
            widgetOptions.push(new widgetOption("textSize", this.textPart.fontSize, this.UID));
            widgetOptions.push(new widgetOption("textBold", this.textPart.fontBold, this.UID));
        }

        return widgetOptions;
    }

    getHandlerForOption(name) {
        if (name == "color") {
            return this.menuColor;
        } else if (name == "alignChilds") {
            return this.alignChildsMenu;
        } else if (name == "textSize") {
            return this.menuTextSize;
        } else if (name == "textBold") {
            return this.menuTextBold;
        }
    }


    // Далее для statesManager

    collectChildren(collection) {
        var compare = function ( widgetA, widgetB ) {
            if ( widgetA.startY < widgetB.startY ){
                return -1;
            }
            if ( widgetA.startY > widgetB.startY ){
                return 1;
            }
            return 0;
        }

        let lastLevel = null;

        this.children.sort(compare);
        for (let i = 0; i < this.children.length; i++) {
            let state = this.children[i].getState("full");
            state["level"] = generateKeyBetween(lastLevel, null);
            lastLevel = state["level"];
            collection.push(state);
        }

        for (let i = 0; i < this.children.length; i++) {
            this.children[i].collectChildren(collection);
        }
    }

    getFixType(reason) {
        var fixType = "full";

        switch (reason) {
            case "wm_color":
                fixType = "color";
                break;
            case "move":
                fixType = "move";
                break;
            case "parentNode":
                fixType = "parentNode";
        }

        return fixType;
    }

    getState(fixType) {
        var state = {};

        switch (fixType) {
            case "color":
                state["color"] = this.color;
                break;
            case "move":
                state["startX"] = this.startX;
                state["startY"] = this.startY;
                state["direction"] = this.direction;
                break;
            case "parentNode":
                state["parentNode"] = this.parentNode;
                break;
            case "full":
                state["UID"] = this.UID;
                state["parentUID"] = this.parentUID;
                state["entityType"] = "treeNodeWidget";
                state["parentNode"] = this.parentNode; // не путать с parentUID
                state["startX"] = this.startX;
                state["startY"] = this.startY;
                state["textPart"] = this.textPart.getState("full");
                state["height"] = this.height;
                state["horizontalPadding"] = this.horizontalPadding;
                state["color"] = this.color;
                state["direction"] = this.direction;
                break;
        }

        return state;
    }

    loadState(stateObj, fixType) {
        switch (fixType) {
            case "color":
                this.color = getColorProperty("color", stateObj);
                break;
            case "move":
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                this.direction = getStringProperty("direction", stateObj);
                break;
            case "parentNode":
                this.registerNodeParent(getStringProperty("parentNode", stateObj));
                break;
            case "full":
                this.UID = getStringProperty("UID", stateObj);
                this.parentUID = getStringProperty("parentUID", stateObj);
                this.startX = getNumberProperty("startX", stateObj);
                this.startY = getNumberProperty("startY", stateObj);
                this.parentNode = getStringProperty("parentNode", stateObj);
                this.textPart.loadState(stateObj["textPart"], "full");
                this.height = getNumberProperty("height", stateObj);
                this.horizontalPadding = getNumberProperty("horizontalPadding", stateObj);
                this.direction = getStringProperty("direction", stateObj);
                this.color = getColorProperty("color", stateObj);
                break;

        }

        this.updateDims();
    }



    constructorName = "treeNode";
    width = 0; // >= minWidth. Рассчитывается в updateDims
    textPart = null;
    children = []; // uids of treeNode widgets
    topSelected = "";

    // константы
    minWidth = 250;
    horizontalPadding = 30;
    fontSize = 25;

    // сохраняемые данные
    startX = 0;
    startY = 0;
    height = 0;
    direction = "right";
    color = "#6F38F5";
    parentNode = ""; // parent node UID

}
